/**
 * Money formatting helpers — loaded synchronously so inline PDP scripts
 * can call parseMoneyAmount/formatMoney before deferred global.js runs.
 */
(function () {
  if (typeof window.formatMoney === "function" && typeof window.parseMoneyAmount === "function") {
    return;
  }

  window.formatMoney = function (cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.Shopify && window.Shopify.money_format) || "${{amount}}";

    function defaultTo(value, defaultValue) {
      return typeof value === "undefined" || value === null ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return "0";
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) {
      return formatString + (Number(cents) / 100).toFixed(2);
    }

    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  };

  window.parseMoneyAmount = function (text) {
    if (text == null) return NaN;
    var cleaned = String(text)
      .replace(/[^\d.,-]/g, "")
      .trim();
    if (!cleaned) return NaN;

    var lastComma = cleaned.lastIndexOf(",");
    var lastDot = cleaned.lastIndexOf(".");

    if (lastComma > lastDot) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else {
      cleaned = cleaned.replace(/,/g, "");
    }

    return parseFloat(cleaned);
  };

  if (typeof window.Shopify !== "undefined" && typeof window.Shopify.formatMoney !== "function") {
    window.Shopify.formatMoney = window.formatMoney;
  }
})();
